import { ErrorCircle, SuccessCircle } from "components/assets/Icons";
import styles from "./Message.module.scss";

const Message = ({
  text,
  showMessage,
  typeOfMessage = "success",
  customStyles,
}) => {
  let iconComponent;
  let additionalStyles = "";

  const typeStyles = {
    success: styles.success,
    error: styles.error,
  };

  if (typeOfMessage === "success") {
    iconComponent = <SuccessCircle />;
  } else if (typeOfMessage === "error") {
    iconComponent = <ErrorCircle />;
  } else if (typeOfMessage === "info") {
    iconComponent = <ErrorCircle />;
  }

  additionalStyles = typeStyles[typeOfMessage] || "";

  return (
    <div
      className={`${styles.messageContainer} ${
        showMessage ? styles.show : ""
      } ${additionalStyles} ${customStyles}`}
      style={customStyles}
    >
      {iconComponent}

      <p className={styles.text}>{text}</p>
    </div>
  );
};

export default Message;
